import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { Color } from 'ng2-charts-x';
import { ChartDataSets, ChartOptions, Label } from 'chart.js';
import { DailyLegLoadGraphService } from '../../../services/daily-leg-loads/daily-leg-load-graph.service';
import { DailyLegLoadGraphFilters } from '../../../models/daily-leg-loads/daily-leg-load.models';
import { TimeZoneService } from '../../../services/time-zone/time-zone.service';
import { DateService } from '../../../services/date/date.service';
import { AppConfig } from '../../../app/app.config';
import { DateTime } from 'luxon';
import { PtLuxonDate } from '../../../models/projects/date.models';

@IonicPage()
@Component({
  selector: 'page-daily-leg-load-graph',
  templateUrl: 'daily-leg-load-graph.html',
})
export class DailyLegLoadGraphPage {
  config = AppConfig.settings;

  loading: boolean;
  date: DateTime;
  startDate: DateTime;
  endDate: DateTime;
  isWeb: boolean;

  lineChartData: ChartDataSets[] = [];
  lineChartLabels: Label[];
  lineChartOptions: (ChartOptions & { annotation: any }) = {
    scales: {
      yAxes: [{
        ticks: {
          userCallback: function (label, index, labels) {
            // when the floored value is the same as the value we have a whole number
            if (Math.floor(label) === label) {
              return label;
            }

          }
        }
      }]
    },
    plugins: {
      zoom: {
        pan: {
          enabled: true,
          mode: 'xy',
          rangeMin: {
            // Format of min pan range depends on scale type
            x: null,
            y: null
          },
        },
        zoom: {
          enabled: true,
          mode: 'xy',
          rangeMin: {
            // Format of min pan range depends on scale type
            x: null,
            y: null
          },
        }
      }
    },
    responsive: true,
  };
  lineChartColors: Color[] = []; // let chart js pick colors instead of hardcoding 4. so 6 legs gets different.
  lineChartLegend = true;
  lineChartType = 'line';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private dailyLegLoadGraphService: DailyLegLoadGraphService,
    private timeZoneService: TimeZoneService,
    private dateService: DateService,
    public platform: Platform,
  ) {
  }

  async ngOnInit() {
    this.loading = true;
    this.isWeb = this.platform.is('core');

    this.date = this.navParams.get('date');

    this.startDate = this.date;
    this.endDate = this.date;

    this.updateGraph();
  }

  async updateGraph() {
    this.loading = true;
    this.lineChartData = [];

    let startDateCopy = this.startDate;
    // add 1 day to end date, because there's no time picker with the datepicker - it means it is using the start time of a day
    let endDateCopy = (await this.dateService.incrementDay(new PtLuxonDate(this.endDate))).dateTime;

    const filters = new DailyLegLoadGraphFilters();
    filters.startDate = startDateCopy;
    filters.endDate = endDateCopy;

    const graphData = await this.dailyLegLoadGraphService.getDailyLoadGraphData(filters);

    this.lineChartLabels = graphData.dateTimeLabels;

    (graphData.series || []).forEach((s) => {
      this.lineChartData.push({
        data: s.data,
        label: `Leg Load ${s.legNumber}`,
        pointHoverRadius: 7,
        pointRadius: 5,
        lineTension: 0,
      });
    });

    this.loading = false;
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-graph/daily-leg-load-graph.ts